import "../../common/styles/components/easy-loading.css";

const Loading = () => {
  return (
    <div
      id="easy-loading-main"
      className="easy-loading-main"
      style={{ 
        position: "fixed", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        width: "100%", 
        height: "100%", 
        top: 0, 
        left: 0 
      }}
    >
      <div className="easy-loading-bkg" style={{ backgroundColor: "black" }}></div>
      <div id="easy-loading-div" className="easy-loading-div">
        <div
          id="easy-loading-content"
          style={{
            top: "50%", 
            position: "absolute", 
            left: "50%", 
            transform: "translate(-50%, -50%)", 
            textAlign: "center" 
          }}
        >
          <div className="ball-scale-multiple">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div
          id="easy-loading-text"
          className="easy-loading-text"
          style={{ 
            paddingTop: "100px", 
            top: "50%", 
            position: "absolute", 
            left: "50%", 
            transform: "translate(-50%, -50%)", 
            textAlign: "center" 
          }}
        >
          Espere por favor, procesando datos...
        </div>
        <button
          id="easy-loading-button"
          className="easy-loading-button"
          style={{ display: "none" }}
        ></button>
      </div>
    </div>
  );
};
export default Loading;
